var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-tabs',{attrs:{"vertical":_vm.window.width >= 407 ? false : true,"nav-wrapper-class":"w-100"}},[_c('b-tab',{attrs:{"title":"تسویه ها","active":""}},[_c('ayandereport')],1),_c('b-tab',{attrs:{"title":"برداشت های به تاریخ"}},[_c('ayandecredit')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }